module.exports = __webpack_public_path__ + "img/img10.2b4f2fce.png";